import React, { useEffect, useState } from 'react';
import { GetRequest, Tooltip, ValidatorFactory } from 'components/common';

// "Maximum material length" select for a glueing machine. The selectable values live in SystemParam rows
// (so they can be edited without a deploy): millimetre users pick the millimetre-native machine sizes,
// inch users pick the inch-native sizes written as fractions. The picked value is stored in that unit
// (together with a hidden max_material_length_unit) and converted to millimetres only when comparing
// against the box's longest side to hide machines that cannot glue a material that long.
const GlueingMaxMaterialLengthSelectFormField = ({ config, value, setValue, register, errors, disabled }) => {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    GetRequest({
      url: `/quote-builder/glueing/max_material_length_options?unit=${window.user_unit}`,
      useCache: true,
      callback: (data) => { setOptions(data); }
    });
  }, []);

  const onChange = (e) => {
    setValue(config.name, e.target.value);
  };

  // Run the configured client-side validators (e.g. NonEmptyValidator) so a missing selection surfaces
  // as an inline "Required" message on this field instead of a raw backend "missing attribute" error.
  const validate = (val) => {
    if (config.validators != undefined) {
      for (let i = 0; i < config.validators.length; i++) {
        let validator = config.validators[i];
        if (!ValidatorFactory(validator, val)) {
          return t(`quote_builder.validator_${validator}_message`);
        }
      }
    }
  };

  return (
    <tr>
      <td>
        {t(config.label)} {config.tooltip_text != undefined && <Tooltip title={t(config.tooltip_text)} />}
        {config.helper_text != undefined && (
          <><br /><small className="form-text text-muted" dangerouslySetInnerHTML={{ __html: t(config.helper_text) }} /></>
        )}
      </td>
      <td align="right">
        <select
          value={value || ''}
          name={config.name}
          disabled={disabled}
          className={`${errors[config.name] ? 'input-error form-control general-frm-element' : 'form-control general-frm-element'}`}
          {...register(config.name, { validate: validate, onChange: onChange })}
        >
          <option value="">{t('quote_builder.select')}</option>
          {options.map((option) => {
            return <option key={option.value} value={option.value}>{option.label}</option>;
          })}
        </select>
        {errors[config.name] && <small className="error"> {errors[config.name].message} </small>}
      </td>
    </tr>
  );
};

export default GlueingMaxMaterialLengthSelectFormField;
